export default __webpack_public_path__ + "static/hw_ff_leds_schem-779be1b5898e5916802045110b1566a2.png";